export class AccountRequestError extends Error {
  constructor(public kind: 'authentication' | 'timeout' | 'canceled' | 'request', message: string) {
    super(message);
    this.name = 'AccountRequestError';
  }
}

export const accountRequestMessage = (error: unknown): string =>
  error instanceof AccountRequestError
    ? error.message
    : "We couldn't connect. Please try again, or contact hello@topclip.ai.";
